export const APP_NAME = 'reports';

